module.exports = __webpack_public_path__ + "img/b2.5974545e.jpg";